export default __webpack_public_path__ + "static/media/location.7671bee6.svg";